import type { Route } from "./+types/mentorship-book";
import Page from "../pages/MentorshipBook";
import { pageMeta } from "../lib/meta";
import { content } from "../lib/content";
import { OG_IMAGE } from "../config/heroArt";

// /mentorship/book/:slug — one page per session type. Server-rendered from the
// admin-managed service, so each is its own indexable landing page ("Book a Mock
// Interview") rather than a modal hanging off /mentorship.
export async function loader({ params }: Route.LoaderArgs) {
  // `content.mentorshipService` throws a Response on a 404, which is what turns
  // an unknown or unpublished slug into a real 404 instead of a blank form.
  return { service: await content.mentorshipService(params.slug) };
}

export function meta({ data, params }: Route.MetaArgs) {
  const service = data?.service;
  const price = service?.isFree ? "Free" : service?.price;
  return pageMeta({
    title: `Book a ${service?.title ?? "session"} | Gazar`,
    description:
      service?.description ??
      "Request a 1:1 session with Ehsan Gazar. Offer the times that work for you and get a confirmed slot within 24 hours.",
    path: `/mentorship/book/${params.slug}`,
    image: OG_IMAGE.mentorship,
    jsonLd: service
      ? {
          "@context": "https://schema.org",
          "@type": "Service",
          name: service.title,
          description: service.description ?? undefined,
          provider: { "@type": "Person", name: "Ehsan Gazar", url: "https://gazar.dev" },
          serviceType: "Software engineering mentorship",
          ...(price && !service.isFree
            ? { offers: { "@type": "Offer", price: service.priceValue, priceCurrency: "USD" } }
            : {}),
        }
      : undefined,
  });
}

export default function R({ loaderData }: Route.ComponentProps) {
  return <Page service={loaderData.service} />;
}
